import React, { useContext, useEffect } from 'react'
import { PhTabs } from 'usbc-web-react-partnerhub-library'
import { useParams } from "react-router-dom";
import GlobalContext from '../../../store/global-context'
import OrderStatusPill from '../../shared/OrderStatusPill/OrderStatusPill'
import './EditOrder.css'

function EditOrder(props) {

    const globalCtx = useContext(GlobalContext);

    useEffect(() => {
        globalCtx.setOrderInEdit(null);
    }, []);

    let { oid } = useParams();

    let tabs = [
        {
            name: 'Return to List of Orders',
            route: '/',
            icon: <i className="bi bi-arrow-left"></i>
        }
    ];

    return (
        <>
            <div className="d-flex justify-content-between border-bottom pb-3">
                <div className="d-flex align-items-center justify-content-start">
                    <div className="settings-order-title me-2">
                        {globalCtx?.orderInEdit?.name}
                    </div>
                    {globalCtx?.orderInEdit?.status && <OrderStatusPill status={globalCtx?.orderInEdit?.status} />}
                </div>
            </div>
            <PhTabs tabs={tabs} />
            <div className='mt-4'>
                {props.children}
            </div>
        </>
    )
}

export default EditOrder